/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

import InputLabel from 'components/generics/InputLabel/InputLabel';
import Input from 'components/generics/Input/Input';
import Select from 'components/generics/Select/Select';
import Button from 'components/generics/Button/Button';
import ChecklistSection from 'components/generics/Checklist/ChecklistSection';

import { updateForm } from 'utils/func';

import { getById as getAirportById, add as addAirport, edit as editAirport } from 'services/API/Airport';
import { getTemplates } from 'services/API/Checklist';

/**
 * Convertit la valeur saisie d'un champ numérique en nombre.
 * Renvoie `null` si le champ est vide ou invalide.
 * On garde la valeur brute (chaîne) dans le state pour pouvoir saisir
 * 0, des décimales ou un time lag négatif sans que la saisie soit écrasée.
 */
const toNullableNumber = value => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const FormAirport = ({ onSubmit, editId, type }) => {
  const DEFAULT_VALUES = {
    icaoCode: '',
    civilCode: '',
    taxiingTime: '',
    transferTime: '',
    timeLagUtc: '',
    fuelAvailable: '',
    checklistTemplateId: 0,
  };

  const [formDatas, setFormDatas] = useState(DEFAULT_VALUES);
  const [checklistModels, setChecklistModels] = useState([]);

  useEffect(() => {
    getTemplates()
      .then(res => setChecklistModels(res.data || []))
      .catch(e => console.error(e));

    if (type === 'edit') {
      getAirportById(editId)
        .then(res => {
          setFormDatas({
            id: res.data.id,
            icaoCode: res.data.icaoCode,
            civilCode: res.data.civilCode,
            taxiingTime: res.data.taxiingTime,
            transferTime: res.data.transferTime,
            timeLagUtc: res.data.timeLagUtc,
            fuelAvailable: res.data.fuelAvailable,
            checklistTemplateId: res.data.checklistTemplateId ?? 0,
          });
        })
        .catch(e => console.error(e));
    }
  }, []);

  const validateData = () => {
    // Les champs numériques sont stockés sous forme de chaînes pendant la
    // saisie, on les convertit en nombres (0 inclus) au moment de l'envoi.
    const payload = {
      ...formDatas,
      taxiingTime: toNullableNumber(formDatas.taxiingTime),
      transferTime: toNullableNumber(formDatas.transferTime),
      timeLagUtc: toNullableNumber(formDatas.timeLagUtc),
      fuelAvailable: toNullableNumber(formDatas.fuelAvailable),
      checklistTemplateId: formDatas.checklistTemplateId ? +formDatas.checklistTemplateId : null,
    };

    if (type === 'edit') {
      editAirport(payload)
        .then(e => {
          setFormDatas(DEFAULT_VALUES);
          onSubmit();
        })
        .catch(err => console.log(err));
    } else {
      addAirport(payload)
        .then(e => {
          setFormDatas(DEFAULT_VALUES);
          onSubmit();
        })
        .catch(err => console.log(err));
    }
  };

  const action = () => (type === 'edit' ? 'Edit' : 'Add an');

  return (
    <div className="modal__content">
      <h2>{action()} airport</h2>
      <div className="form-part">
        <InputLabel label="ICAO code" name="icaoCode">
          <Input name="icaoCode" type="string" onChange={value => updateForm(formDatas, setFormDatas, 'icaoCode', value)} value={formDatas.icaoCode} />
        </InputLabel>
        <InputLabel label="Civil name" name="civilCode">
          <Input name="civilCode" type="string" onChange={value => updateForm(formDatas, setFormDatas, 'civilCode', value)} value={formDatas.civilCode} />
        </InputLabel>
        <InputLabel label="Taxi time" name="taxiingTime">
          <Input
            name="taxiingTime"
            type="number"
            onChange={value => updateForm(formDatas, setFormDatas, 'taxiingTime', value)}
            value={formDatas.taxiingTime ?? ''}
          />
        </InputLabel>
        <InputLabel label="Transfer time" name="transferTime">
          <Input
            name="transferTime"
            type="number"
            onChange={value => updateForm(formDatas, setFormDatas, 'transferTime', value)}
            value={formDatas.transferTime ?? ''}
          />
        </InputLabel>
        <InputLabel label="Time lag(UTC)" name="timeLagUtc">
          <Input
            name="timeLagUtc"
            type="number"
            onChange={value => updateForm(formDatas, setFormDatas, 'timeLagUtc', value)}
            value={formDatas.timeLagUtc ?? ''}
          />
        </InputLabel>
        <InputLabel label="Fuel available" name="fuel">
          <Input
            name="fuel"
            type="number"
            onChange={value => updateForm(formDatas, setFormDatas, 'fuelAvailable', value)}
            value={formDatas.fuelAvailable ?? ''}
          />
        </InputLabel>
        <InputLabel label="Checklist model" name="checklistTemplate">
          <Select
            name="checklistTemplate"
            options={[{ name: 'Aucun modèle', id: 0 }, ...checklistModels]}
            itemValue="id"
            itemLabel="name"
            onChange={value => updateForm(formDatas, setFormDatas, 'checklistTemplateId', +value)}
            value={formDatas.checklistTemplateId}
          />
        </InputLabel>
        {type === 'edit' && formDatas.id ? (
          <div className="form-part__checklist">
            <ChecklistSection entityType="airport" entityId={formDatas.id} canEdit />
          </div>
        ) : null}
      </div>
      <Button text={`${action()} airport`} disabled={false} defaultStyle={`primary`} onClick={e => validateData(e)} />
    </div>
  );
};

export default FormAirport;
